import { NAME } from './constants';

export const FETCH_PANEL_BRANDS = `${NAME}/FETCH_PANEL_BRANDS`;
export const FETCH_PANEL_BRANDS_FAILURE = `${NAME}/FETCH_PANEL_BRANDS_FAILURE`;
export const FETCH_PANEL_BRANDS_SUCCESS = `${NAME}/FETCH_PANEL_BRANDS_SUCCESS`;

export const FETCH_PANELS = `${NAME}/FETCH_PANELS`;
export const FETCH_PANELS_FAILURE = `${NAME}/FETCH_PANELS_FAILURE`;
export const FETCH_PANELS_SUCCESS = `${NAME}/FETCH_PANELS_SUCCESS`;

export const FETCH_ROOF_TYPES = `${NAME}/FETCH_ROOF_TYPES`;
export const FETCH_ROOF_TYPES_FAILURE = `${NAME}/FETCH_ROOF_TYPES_FAILURE`;
export const FETCH_ROOF_TYPES_SUCCESS = `${NAME}/FETCH_ROOF_TYPES_SUCCESS`;

export const FETCH_SYSTEM_TYPES = `${NAME}/FETCH_SYSTEM_TYPES`;
export const FETCH_SYSTEM_TYPES_FAILURE = `${NAME}/FETCH_SYSTEM_TYPES_FAILURE`;
export const FETCH_SYSTEM_TYPES_SUCCESS = `${NAME}/FETCH_SYSTEM_TYPES_SUCCESS`;

export const INITIALIZE = `${NAME}/INITIALIZE`;
export const INITIALIZE_SUCCESS = `${NAME}/INITIALIZE_SUCCESS`;
export const INITIALIZE_FAILURE = `${NAME}/INITIALIZE_FAILURE`;

export const INITIALIZE_VALUES = `${NAME}/INITIALIZE_VALUES`;

export const RESET = `${NAME}/RESET`;
export const RESET_FORM = `${NAME}/RESET_FORM`;

export const SAVE_PROPOSAL = `${NAME}/SAVE_PROPOSAL`;
export const SAVE_PROPOSAL_FAILURE = `${NAME}/SAVE_PROPOSAL_FAILURE`;
export const SAVE_PROPOSAL_SUCCESS = `${NAME}/SAVE_PROPOSAL_SUCCESS`;

export const SET_IS_NEW_RECORD = `${NAME}/SET_IS_NEW_RECORD`;

export const SET_IS_OPEN_MODAL = `${NAME}/SET_IS_OPEN_MODAL`;
